import { render, staticRenderFns } from "./demo-block.vue?vue&type=template&id=5ba120d2"
import script from "./demo-block.vue?vue&type=script&lang=js"
export * from "./demo-block.vue?vue&type=script&lang=js"
import style0 from "./demo-block.vue?vue&type=style&index=0&id=5ba120d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports